export class PlaneClassification {
  // "back" is synonymous with "in", but used for planes (back of plane is "inside" a solid volume walled by a plane)
  public static readonly BACK: number = 0;
  public static readonly FRONT: number = 1;

  public static readonly IN: number = 0;
  public static readonly OUT: number = 1;
  public static readonly INTERSECT: number = 2;
}
